module.exports = __webpack_public_path__ + "img/clothing32.0f2f672e.jpg";